import loadable from '@loadable/component';
import { Flex, Grid, theme } from 'antd';
import { createBrowserRouter, Navigate, RouteObject } from 'react-router-dom';
import { App, AppAdmin, AppPOS } from './app';
import { IS_POS } from '@/utils/env';
import { EmptyRoute } from '@/components/EmptyRoute';
import LoadingCom from '@/components/Loading';

const Loading = () => {
  const { xs } = Grid.useBreakpoint();
  const { token } = theme.useToken();
  return (
    <Flex
      align="center"
      justify="center"
      style={{ margin: token.margin, height: '100%', background: token.colorBgContainer }}>
      <LoadingCom />
    </Flex>
  );
};

export const Loadable = ({ loader }) =>
  loadable(loader, {
    fallback: <Loading />,
  });

// export const Loadable = ({ loader }) => {
//   const Component = loadable(loader, {
//     fallback: <Loading />,
//   });

//   // v6 element 需要 JSX 元素，这里直接返回一个函数组件内部渲染 JSX
//   return <Component />;
// };

export const Pos_Pages = {
  launcher: {
    com: Loadable({
      loader: () => import('./pages/POS/Pages/Launcher'),
    }),
  },
  checkout: {
    com: Loadable({
      loader: () => import('./pages/POS'),
    }),
  },
  orderList: {
    com: Loadable({
      loader: () => import('./pages/Order/List'),
    }),
  },
  appointmentList: {
    com: Loadable({
      loader: () => import('./pages/Appointment/List'),
    }),
  },
  assistedBook: {
    com: Loadable({
      loader: () => import('./pages/Appointment/AssistedBook'),
    }),
  },
  specialSlots: {
    com: Loadable({
      loader: () => import('./pages/Appointment/SpecialSlots'),
    }),
  },
  stockList: {
    com: Loadable({
      loader: () => import('./pages/Inventory/StockList'),
    }),
  },
  skuList: {
    com: Loadable({
      loader: () => import('./pages/Sku/List'),
    }),
  },
  inventoryStockTaking: {
    com: Loadable({
      loader: () => import('./pages/Inventory/StockTaking'),
    }),
  },
  inventoryPurchase: {
    com: Loadable({
      loader: () => import('./pages/Inventory/Purchase'),
    }),
  },
  userList: {
    com: Loadable({
      loader: () => import('./pages/User'),
    }),
  },
  dashboard: {
    com: Loadable({
      loader: () => import('./pages/Dashboard'),
    }),
  },
  system: {
    com: Loadable({
      loader: () => import('./pages/POS/Pages/System'),
    }),
  },
  statisticsSummary: {
    com: Loadable({
      loader: () => import('./pages/Statistics/Summary'),
    }),
  },
  punchOut: {
    com: Loadable({
      loader: () => import('./pages/POS/Pages/PunchOut'),
    }),
  },
};

export const routes: RouteObject[] = [
  {
    path: '/login',
    Component: Loadable({
      loader: () => import('./pages/Login'),
    }),
  },
  {
    path: '/register',
    Component: Loadable({
      loader: () => import('./pages/Register'),
    }),
  },

  {
    Component: App,
    children: [
      IS_POS
        ? {
            Component: AppPOS,
            path: '/POS',
            children: [
              {
                path: '/POS/index',
                Component: Pos_Pages.launcher.com,
              },
              {
                path: '/POS/checkout',
                Component: Pos_Pages.checkout.com,
              },
              {
                path: '/POS/order/:orderSn?',
                Component: Pos_Pages.orderList.com,
              },
              {
                path: '/POS/appointment/list',
                Component: Pos_Pages.appointmentList.com,
              },
              {
                path: '/POS/appointment/assistedBook',
                Component: Pos_Pages.assistedBook.com,
              },
              {
                path: '/POS/appointment/specialSlots',
                Component: Pos_Pages.specialSlots.com,
              },
              {
                path: '/POS/stock',
                Component: Pos_Pages.stockList.com,
              },
              {
                path: '/POS/inventory/stockTaking',
                Component: Pos_Pages.inventoryStockTaking.com,
              },
              {
                path: '/POS/inventory/purchase',
                Component: Pos_Pages.inventoryPurchase.com,
              },
              {
                path: '/POS/sku',
                Component: EmptyRoute,
                children: [
                  {
                    path: '/POS/sku',
                    Component: Pos_Pages.skuList.com,
                  },
                ],
              },
              {
                path: '/POS/user',
                Component: Pos_Pages.userList.com,
              },
              {
                path: '/POS/statistics',
                Component: Pos_Pages.statisticsSummary.com,
              },
              {
                path: '/POS/system',
                Component: Pos_Pages.system.com,
              },
              {
                path: '/POS/punchOut',
                Component: Pos_Pages.punchOut.com,
              },
            ],
          }
        : {
            Component: AppAdmin,
            children: [
              { path: '/', Component: () => <Navigate to="/dashboard" /> },
              {
                path: '/dashboard',
                // Component: Loading,
                Component: Loadable({
                  loader: () => import('./pages/Dashboard'),
                }),
              },
              {
                path: '/statistics',
                Component: EmptyRoute,
                children: [
                  {
                    path: '/statistics/summary',
                    Component: Loadable({
                      loader: () => import('./pages/Statistics/Summary'),
                    }),
                  },
                  {
                    path: '/statistics/visit',
                    Component: Loadable({
                      loader: () => import('./pages/Statistics/Visit'),
                    }),
                  },
                  {
                    path: '/statistics/sku',
                    Component: Loadable({
                      loader: () => import('./pages/Statistics/Sku'),
                    }),
                  },
                  {
                    path: '/statistics/order',
                    Component: Loadable({
                      loader: () => import('./pages/Statistics/Order'),
                    }),
                  },
                ],
              },
              {
                path: '/profile',
                Component: Loadable({
                  loader: () => import('./pages/Profile'),
                }),
              },
              {
                path: '/sku',
                Component: EmptyRoute,
                children: [
                  {
                    path: '/sku/publish/:id?',
                    Component: Loadable({
                      loader: () => import('./pages/Sku/Publish'),
                    }),
                  },
                  {
                    path: '/sku/related',
                    Component: Loadable({
                      loader: () => import('./pages/Sku/RelatedList'),
                    }),
                  },
                  {
                    path: '/sku/basic',
                    Component: Loadable({
                      loader: () => import('./pages/Sku/List'),
                    }),
                  },
                  {
                    path: '/sku/category',
                    Component: Loadable({
                      loader: () => import('./pages/Category'),
                    }),
                  },
                ],
              },
              {
                path: '/mkt',
                Component: EmptyRoute,
                children: [
                  {
                    path: '/mkt/task',
                    Component: Loadable({
                      loader: () => import('./pages/MKT/taskList'),
                    }),
                  },
                  {
                    path: '/mkt/publish/task/awaken',
                    Component: Loadable({
                      loader: () => import('./pages/MKT/awaken'),
                    }),
                  },
                ],
              },
              {
                path: '/inventory',
                Component: EmptyRoute,
                children: [
                  {
                    path: '/inventory/stock',
                    Component: Loadable({
                      loader: () => import('./pages/Inventory/StockList'),
                    }),
                  },
                  {
                    path: '/inventory/purchase',
                    Component: Loadable({
                      loader: () => import('./pages/Inventory/Purchase'),
                    }),
                  },
                  {
                    path: '/inventory/sn/:sn',
                    Component: Loadable({
                      loader: () => import('./pages/Inventory/InventoryListDetail'),
                    }),
                  },
                  {
                    path: '/inventory/purchaseHistory',
                    Component: Loadable({
                      loader: () => import('./pages/Inventory/PurchaseHistory'),
                    }),
                  },
                  {
                    path: '/inventory/stockTaking',
                    Component: Loadable({
                      loader: () => import('./pages/Inventory/StockTaking'),
                    }),
                  },
                  {
                    path: '/inventory/stockTakingHistory',
                    Component: Loadable({
                      loader: () => import('./pages/Inventory/StockTakingHistory'),
                    }),
                  },
                  {
                    path: '/inventory/supplier/:supplierId/payment',
                    Component: Loadable({
                      loader: () => import('./pages/Inventory/SupplierPayment'),
                    }),
                  },
                  {
                    path: '/inventory/supplier',
                    Component: Loadable({
                      loader: () => import('./pages/Inventory/SupplierList'),
                    }),
                  },
                ],
              },
              {
                path: '/order/:orderSn?',
                Component: Loadable({
                  loader: () => import('./pages/Order/List'),
                }),
              },
              {
                path: '/appointment',
                Component: EmptyRoute,
                children: [
                  {
                    path: '/appointment/list/:appointmentId?',
                    Component: Loadable({
                      loader: () => import('./pages/Appointment/List'),
                    }),
                  },
                  {
                    path: '/appointment/assistedBook',
                    Component: Loadable({
                      loader: () => import('./pages/Appointment/AssistedBook'),
                    }),
                  },
                  {
                    path: '/appointment/specialSlots',
                    Component: Loadable({
                      loader: () => import('./pages/Appointment/SpecialSlots'),
                    }),
                  },
                ],
              },
              {
                path: '/user',
                Component: EmptyRoute,
                children: [
                  {
                    path: '/user/vipRules',
                    Component: Loadable({
                      loader: () => import('./pages/User/VipRules'),
                    }),
                  },
                  {
                    path: '/user/detail',
                    Component: Loadable({
                      loader: () => import('./pages/User/detail'),
                    }),
                  },
                  {
                    path: '/user',
                    Component: Loadable({
                      loader: () => import('./pages/User'),
                    }),
                  },
                ],
              },

              {
                path: '/wecom',
                Component: EmptyRoute,
                children: [
                  {
                    path: '/wecom/externalContact',
                    Component: Loadable({
                      loader: () => import('./pages/Wecom/ExternalContact'),
                    }),
                  },
                  {
                    path: '/wecom/welcome',
                    Component: Loadable({
                      loader: () => import('./pages/Wecom/Welcome'),
                    }),
                  },
                ],
              },

              {
                path: '/moreme',
                Component: EmptyRoute,
                children: [
                  {
                    path: '/moreme/user',
                    Component: Loadable({
                      loader: () => import('./pages/Moreme/user'),
                    }),
                  },
                  {
                    path: '/moreme/report',
                    Component: Loadable({
                      loader: () => import('./pages/Moreme/report'),
                    }),
                  },
                ],
              },
              {
                path: '/subscribe',
                Component: EmptyRoute,
                children: [
                  {
                    path: '/subscribe/private',
                    Component: Loadable({
                      loader: () => import('./pages/Subscribe/Private'),
                    }),
                  },
                ],
              },
              {
                path: '/marketing',
                Component: EmptyRoute,
                children: [
                  {
                    path: '/marketing/card/edit/:id?',
                    Component: Loadable({
                      loader: () => import('./pages/Marketing/Card/form'),
                    }),
                  },
                  {
                    path: '/marketing/card',
                    Component: Loadable({
                      loader: () => import('./pages/Marketing/Card'),
                    }),
                  },
                  {
                    path: '/marketing/cardUser',
                    Component: Loadable({
                      loader: () => import('./pages/Marketing/Card/CardUserListPage'),
                    }),
                  },
                  {
                    path: '/marketing/recharge',
                    Component: Loadable({
                      loader: () => import('./pages/Marketing/Recharge'),
                    }),
                  },
                  {
                    path: '/marketing/point',
                    Component: Loadable({
                      loader: () => import('./pages/Marketing/Point'),
                    }),
                  },
                  {
                    path: '/marketing/couponUser',
                    Component: Loadable({
                      loader: () => import('./pages/Marketing/Coupon/CouponUser'),
                    }),
                  },
                  {
                    path: '/marketing/coupon',
                    Component: Loadable({
                      loader: () => import('./pages/Marketing/Coupon'),
                    }),
                  },
                  {
                    path: '/marketing/secKill',
                    Component: Loadable({
                      loader: () => import('./pages/Marketing/SecKill'),
                    }),
                  },
                  {
                    path: '/marketing/campaign/publish/:sn?',
                    Component: Loadable({
                      loader: () => import('./pages/Marketing/Campaign/Publish'),
                    }),
                  },
                  {
                    path: '/marketing/campaign',
                    Component: Loadable({
                      loader: () => import('./pages/Marketing/Campaign/List'),
                    }),
                  },
                ],
              },
              {
                path: '/operation',
                Component: EmptyRoute,
                children: [
                  {
                    path: '/operation/notice',
                    Component: Loadable({
                      loader: () => import('./pages/Operation/Notice'),
                    }),
                  },
                  {
                    path: '/operation/ad',
                    Component: Loadable({
                      loader: () => import('./pages/Operation/Ad'),
                    }),
                  },
                ],
              },
              {
                path: '/staff',
                Component: EmptyRoute,
                children: [
                  {
                    path: '/staff/basic/form/:username?',
                    Component: Loadable({
                      loader: () => import('./pages/Staff/Basic/StaffForm'),
                    }),
                  },
                  {
                    path: '/staff/basic',
                    Component: Loadable({
                      loader: () => import('./pages/Staff/Basic/List'),
                    }),
                  },
                  {
                    path: '/staff/attendance',
                    Component: Loadable({
                      loader: () => import('./pages/Staff/Attendance'),
                    }),
                  },
                  {
                    path: '/staff/handoverLog',
                    Component: Loadable({
                      loader: () => import('./pages/Staff/HandoverLog'),
                    }),
                  },
                  {
                    path: '/staff/role/publish/:id?',
                    Component: Loadable({
                      loader: () => import('./pages/Staff/Role/Edit'),
                    }),
                  },
                  {
                    path: '/staff/role',
                    Component: Loadable({
                      loader: () => import('./pages/Staff/Role/List'),
                    }),
                  },
                  {
                    path: '/staff/permission',
                    Component: Loadable({
                      loader: () => import('./pages/Staff/Permission'),
                    }),
                  },
                ],
              },
              {
                path: '/poi',
                Component: EmptyRoute,
                children: [
                  {
                    path: '/poi/basic',
                    // Component: PoiInfo,
                    Component: Loadable({
                      loader: () => import('./pages/Poi/Info'),
                    }),
                  },
                  {
                    path: '/poi/appointment',
                    // Component: PoiInfo,
                    Component: Loadable({
                      loader: () => import('./pages/Poi/Appointment'),
                    }),
                  },
                ],
              },
              {
                path: '/weapp',
                Component: EmptyRoute,
                children: [
                  {
                    path: '/weapp/basic',
                    Component: Loadable({
                      loader: () => import('./pages/WeApp/Basic'),
                    }),
                  },
                  {
                    path: '/weapp/code',
                    Component: Loadable({
                      loader: () => import('./pages/WeApp/Code'),
                    }),
                  },
                  {
                    path: '/weapp/style',
                    Component: Loadable({
                      loader: () => import('./pages/WeApp/Style'),
                    }),
                  },
                ],
              },
              {
                path: '/settings',
                Component: EmptyRoute,
                children: [
                  {
                    path: '/settings/mall',
                    Component: Loadable({
                      loader: () => import('./pages/Settings/Mall'),
                    }),
                  },
                  {
                    path: '/settings/payment',
                    Component: Loadable({
                      loader: () => import('./pages/Settings/Payment'),
                    }),
                  },
                  {
                    path: '/settings/sms',
                    Component: Loadable({
                      loader: () => import('./pages/Settings/Sms'),
                    }),
                  },
                  {
                    path: '/settings/notifications',
                    Component: Loadable({
                      loader: () => import('./pages/Settings/Notifications'),
                    }),
                  },
                  {
                    path: '/settings/protocols',
                    Component: Loadable({
                      loader: () => import('./pages/Settings/Protocols'),
                    }),
                  },
                ],
              },
              {
                path: '/system',
                Component: EmptyRoute,
                children: [
                  {
                    path: '/system/poi',
                    Component: Loadable({
                      loader: () => import('./pages/System/Poi/List'),
                    }),
                  },
                  {
                    path: '/system/staff',
                    Component: Loadable({
                      loader: () => import('./pages/System/Staff/List'),
                    }),
                  },
                  {
                    path: '/system/device/pos',
                    Component: Loadable({
                      loader: () => import('./pages/System/Device/Pos'),
                    }),
                  },
                  {
                    path: '/system/app/pos',
                    Component: Loadable({
                      loader: () => import('./pages/System/App/Pos'),
                    }),
                  },
                  {
                    path: '/system/sp/list',
                    Component: Loadable({
                      loader: () => import('./pages/System/StandardProductMng/List'),
                    }),
                  },
                  {
                    path: '/system/permission',
                    Component: Loadable({
                      loader: () => import('./pages/System/Permission/Main'),
                    }),
                  },
                ],
              },
              {
                path: '/test',
                Component: EmptyRoute,
                children: [
                  {
                    path: '/test/staffSelector',
                    Component: Loadable({
                      loader: () => import('./pages/Test/StaffSelector'),
                    }),
                  },
                  {
                    path: '/test/userSelector',
                    Component: Loadable({
                      loader: () => import('./pages/Test/UserSelector'),
                    }),
                  },
                ],
              },
            ],
          },
    ],
  },
];

export const browserRouter = createBrowserRouter(routes);

if (IS_POS) {
  Object.entries(Pos_Pages).forEach(([key, { com }]) => {
    com.preload();
  });
}
